export default "__VITE_ASSET__cU_s$EMA__"